import register from '../../../../global/js/registry';
export default register('a-fab-button', () => import(/* webpackMode: "lazy" */ './a-fab-button.controller'));
